import { render, staticRenderFns } from "./ProposedLifeInsured.vue?vue&type=template&id=3a5efd6f"
import script from "./ProposedLifeInsured.vue?vue&type=script&lang=js"
export * from "./ProposedLifeInsured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports